const Error = ({ errorText }) => {
  return <div>{errorText}</div>
}

export default Error
